module.exports = __webpack_public_path__ + "static/chat-37af9d679fa2cf89d12bced17a23c041.png";